<!-- <pre>{{ user() | json }}</pre> -->
@if(user()){
<div class="flex items-center gap-2 text-xl bg-iris p-4 rounded-md">
  <div class="image-user">
    <span class="uppercase"
      >{{ user()?.data?.first_name | slice : 0 : 1
      }}{{ user()?.data?.last_name | slice : 0 : 1 }}</span
    >
  </div>
  <p class="font-medium text-white">
    {{ user()?.data?.first_name }} {{ user()?.data?.last_name }}
  </p>
</div>
<ul class="mt-5 font-medium flex flex-col gap-4 ps-4">
  <li class="flex items-baseline gap-2">
    <span class="pi pi-envelope"></span>
    <span>Email: {{ user()?.data?.email }}</span>
  </li>
  <li class="flex items-baseline gap-2">
    <span class="pi pi-check"></span>
    <span>Status: {{ user()?.data?.status ? "Aktivan" : "Neaktivan" }}</span>
  </li>
  @if(user()?.data?.roles){ @for(role of user()?.data?.roles; track role.id){
  <li class="flex items-baseline gap-2">
    <span class="pi pi-crown"></span>
    <span>Uloga: {{ role.name }}</span>
  </li>
  <li class="flex items-baseline gap-2">
    <span class="pi pi-list"></span>
    <div class="w-full">
      <span>Permisije: </span>
      <p-accordion [value]="0">
        @for(ability of abilities; track ability.tag){
        <p-accordion-panel [value]="ability.tag">
          <p-accordion-header>{{ ability.tag }}</p-accordion-header>
          @for(description of ability.descriptions; track $index){
          <p-accordion-content>
            <p-chip>
              <p class="m-0">{{ description }}</p>
            </p-chip>
          </p-accordion-content>
          }
        </p-accordion-panel>
        }
      </p-accordion>
    </div>
  </li>
  } }
</ul>
}
